import mainUrl from './main_url'
const baseUrlConfig = {
    'development': '/otssign/dev/api/sign/',
    // 'test' : 'http://172.16.6.130:8080/oxer',
    'production': `${mainUrl}/api/sign/`,
}
const getBaseurl = mode => baseUrlConfig[mode];
const domainName = getBaseurl(process.env.NODE_ENV)
let environment = process.env.NODE_ENV === 'development' ? '/otssign/dev' : mainUrl

// 公共接口
export const getLogo = domainName + 'Public/getLogo'
export const getTenantSmsConfig = domainName + 'Public/getTenantSmsConfig'
export const getSystemNameFN = domainName + 'Public/getSystemName'
export const testLogin = domainName + 'auth/login'
export const outLogin = `${environment}/logout`
export const imageCheckCodeOne = `${environment}/imageCheckCode`
export const editPsd = domainName + 'auth/changePwd'
export const verification = domainName + 'auth/verification'
export const queryInfo = domainName + 'auth/queryInfo'
export const getServerTime = domainName + 'Initiate/getServerTime'
export const phoneCheckCode = domainName + "auth/phoneCheckCode"
export const checkUserCardPhone = domainName + "auth/checkUserCardPhone"
export const checkPhoneCode = domainName + "auth/checkPhoneCode"
export const getSystemName = domainName + "custom/getSystemName"
export const getCustom = domainName + "custom/getCustom"
export const saveCustom = domainName + "custom/saveCustom"
export const getTenantSmsTitleList = domainName + "plan/getTenantSmsTitleList"
export const getSignNumber = domainName + 'Initiate/getSignNumber'
export const getRealTimePay = domainName + 'Initiate/getRealTimePay'
export const getScoreDistribution = domainName + 'Initiate/getScoreDistribution'
export const getQRCodeData = domainName + 'Initiate/getQRCodeData'
export const deleteRegisterUserInfo = domainName + 'signUp/deleteRegisterUserInfo'
export const registerUserExport = domainName + 'signUp/registerUserExport'
export const registerUserExcelTempCreate = domainName + 'signUp/registerUserExcelTempCreate'
export const registerUserImport = domainName + 'signUp/registerUserImport'
export const importRegisterUserPhoto = domainName + 'signUp/importRegisterUserPhoto'
export const addRegisterUserInfo = domainName + 'signUp/addRegisterUserInfo'
export const selectRegisterUserByOne = domainName + 'signUp/selectRegisterUserByOne'
export const addSchool = domainName + 'school/addSchool'
export const updateSchool = domainName + 'school/updateSchool'
export const deleteSchool = domainName + 'school/deleteSchool'
export const updateSchoolState = domainName + 'school/updateSchoolState'
export const querySchool = domainName + 'school/querySchool'
export const querySchoolList = domainName + 'school/querySchoolList'
export const queryAllSchool = domainName + 'school/queryAllSchool'
export const addStation = domainName + 'station/addStation'
export const updateStation = domainName + 'station/updateStation'
export const deleteStation = domainName + 'station/deleteStation'
export const updateStationState = domainName + 'station/updateStationState'
export const queryStation = domainName + 'station/queryStation'
export const queryStationList = domainName + 'station/queryStationList'
export const queryAllStation = domainName + 'station/queryAllStation'
export const importStation = domainName + 'station/importStation'
export const exportStation = domainName + 'station/exportStation'
export const getLevelListByRelation = domainName + 'levelSubjectCourse/getLevelListByRelation'
export const getSubjectListByLevel = domainName + 'levelSubjectCourse/getSubjectListByLevel'
export const getCourseListByLevelAndSubject = domainName + 'levelSubjectCourse/getCourseListByLevelAndSubject'
export const selectAllLevelSubjectCourse = domainName + 'levelSubjectCourse/selectAllLevelSubjectCourse'
export const selectLevelSubjectCourseByRequirement = domainName + 'levelSubjectCourse/selectLevelSubjectCourseByRequirement'
export const getLevelSubjectCourseRelation = domainName + 'levelSubjectCourse/getLevelSubjectCourseRelation'
export const delLevelSubjectCourse = domainName + 'levelSubjectCourse/delLevelSubjectCourse'
export const importLevelSubjectCourse = domainName + 'levelSubjectCourse/importLevelSubjectCourse'
export const getLevel = domainName + 'level/getLevel'
export const insertLevel = domainName + 'level/insertLevel'
export const editLevel = domainName + 'level/editLevel'
export const deleteLevel = domainName + 'level/deleteLevel'
export const getLevelBlurred = domainName + 'level/getLevelBlurred'
export const addLevelSubjectCourse = domainName + 'levelSubjectCourse/insertLevelSubjectCourse'
export const selectLevelSubjectCoursePlugs = domainName + 'levelSubjectCourse/selectLevelSubjectCoursePlugs'
export const addSubject = domainName + 'subject/addSubject'
export const updateSubject = domainName + 'subject/updateSubject'
export const deleteSubject = domainName + 'subject/deleteSubject'
export const updateSubjectState = domainName + 'subject/updateSubjectState'
export const querySubject = domainName + 'subject/querySubject'
export const querySubjectList = domainName + 'subject/querySubjectList'
export const queryAllSubject = domainName + 'subject/queryAllSubject'
export const importSubject = domainName + 'subject/importSubject'
export const addCourse = domainName + 'course/addCourse'
export const updateCourse = domainName + 'course/updateCourse'
export const deleteCourse = domainName + 'course/deleteCourse'
export const updateCourseState = domainName + 'course/updateCourseState'
export const queryCourse = domainName + 'course/queryCourse'
export const queryCourseList = domainName + 'course/queryCourseList'
export const queryAllCourse = domainName + 'course/queryAllCourse'
export const getPlanCourse = domainName + 'planCourse/getPlanCourse'
export const updatePlanCourse = domainName + 'planCourse/updatePlanCourse'
export const getOtsManagePages = domainName + 'studentCourse/getOtsManagePages'
export const getPlace = domainName + 'SelectSessionPlace/getPlace'
export const getPlaceInfo = domainName + 'studentCourse/getPlaceInfo'
export const getTrialScoreLineExport = domainName + 'studentCourse/getTrialScoreLineExport'
export const addPlace = domainName + 'place/addPlace'
export const updatePlace = domainName + 'place/updatePlace'
export const deletePlace = domainName + 'place/deletePlace'
export const updatePlaceState = domainName + 'place/updatePlaceState'
export const queryPlace = domainName + 'place/queryPlace'
export const queryPlaceList = domainName + 'place/queryPlaceList'
export const queryAllPlace = domainName + 'place/queryAllPlace'
export const importPlace = domainName + 'place/importPlace'
export const listTime = domainName + 'SelectSessionPlace/listTime'
export const addClass = domainName + 'class/addClass'
export const updateClass = domainName + 'class/updateClass'
export const deleteClass = domainName + 'class/deleteClass'
export const updateClassState = domainName + 'class/updateClassState'
export const queryClass = domainName + 'class/queryClass'
export const queryClassList = domainName + 'class/queryClassList'
export const importClass = domainName + 'class/importClass'
export const exportClass = domainName + 'class/exportClass'
export const uploadCertificateTemplate = domainName + 'entrance/uploadCertificateTemplate'
export const copyLastPlanFiles = domainName + 'plan/copyLastPlanFiles'
export const getPlanExclusiveInfo = domainName + 'plan/getPlanExclusiveInfo'
export const savePlanExclusiveInfo = domainName + 'plan/savePlanExclusiveInfo'
export const addPlan = domainName + 'plan/addPlan'
export const deletePlan = domainName + 'plan/deletePlan'
export const editPlan = domainName + 'plan/editPlan'
export const editPlanState = domainName + 'plan/editPlanState'
export const getList = domainName + 'plan/getList'
export const getPlan = domainName + 'plan/getPlan'
export const getSelectPlan = domainName + 'plan/getSelectPlan'
export const getTourTeacherSession = domainName + 'plan/getTourTeacherSession'
export const getTourTeacherPlace = domainName + 'plan/getTourTeacherPlace'
export const getTourTeacherList = domainName + 'plan/getTourTeacherList'
export const tourTeacherImport = domainName + 'plan/tourTeacherImport'
export const getTourTeacherAddList = domainName + 'plan/getTourTeacherAddList'
export const addTourTeacher = domainName + 'plan/addTourTeacher'
export const delTourTeacher = domainName + 'plan/delTourTeacher'
export const getPlanCode = domainName + 'plan/getPlanCode'
export const getPlanStudent = domainName + 'planRegion/getPlanRegionList'
export const regionImport = domainName + 'planRegion/regionImport'
export const deleteRegion = domainName + 'planRegion/deleteRegion'
export const editRegion = domainName + 'planRegion/editRegion'
export const queryPaperByCourseCode = domainName + 'planClass/queryPaperByCourseCode'
export const uploadEntranceTemplate = domainName + 'entrance/uploadEntranceTemplate'
export const entrancePrintTest = domainName + 'entrance/entrancePrintTest'
export const paymentPicture = domainName + 'plan/paymentPicture'
export const stopPlan = domainName + 'plan/stopPlan'
export const getInfo = domainName + 'planPlaceContact/getInfo'
export const delInfo = domainName + 'planPlaceContact/delInfo'
export const updateInfoiPhone = domainName + 'planPlaceContact/updateInfo'
export const saveInfo = domainName + 'planPlaceContact/saveInfo'
export const submitSimulate = domainName + 'plansimulate/submitSimulate'
export const getEditSimulate = domainName + 'plansimulate/getEditSimulate'
export const examReportInfo = domainName + 'examReport/info'
export const examReportCount = domainName + 'examReport/count'
export const pagelist = domainName + 'courseAnalysis/pagelist'
export const scorePagelist = domainName + 'scoreAnalysis/pagelist'
export const normalData = domainName + 'scoreAnalysis/normalData'
export const listByCourse = domainName + 'scoreSection/listByCourse'
export const getCourseListBySession = domainName + 'planSession/getCourseListBySession'
export const getSessionAddName = domainName + 'planSession/getSessionAddName'
export const addSession = domainName + 'planSession/addSession'
export const editSession = domainName + 'planSession/editSession'
export const deleteSession = domainName + 'planSession/deleteSession'
export const getPlanSessionList = domainName + 'planSession/getPlanSessionList'
export const getPlanPlaceList = domainName + 'planSession/getPlanPlaceList'
export const getChainSessionList = domainName + 'planSession/getChainSessionList'
export const getChainClassList = domainName + 'class/getChainClassList'
export const getPlanAllSessionByPlanId = domainName + 'planSession/getPlanAllSessionByPlanId'
export const getPlaceSessionClassCount = domainName + 'planSession/getPlaceSessionClassCount'
export const getEditSession = domainName + 'planSession/getEditSession'
export const exportClassRoomTitle = domainName + 'planSession/exportClassRoomTitle'
export const getPlanPlaceCourse = domainName + 'planSession/getPlanPlaceCourse'
export const getIpAnalysis = domainName + 'otsIpLog/getIpAnalysis'
export const getIpAnalysisTitle = domainName + 'otsIpLog/getIpAnalysisTitle'
export const getIpAnalysisDetail = domainName + 'otsIpLog/getIpAnalysisDetail'
export const getPlanSignDateCount = domainName + 'planSession/getPlanSignDateCount'
export const getClassList = domainName + 'planSession/getClassList'
export const getFileDeskTitle = domainName + 'planSession/getFileDeskTitle'
export const setStudentClass = domainName + 'planStudent/setStudentClass'
export const getClassStudentList = domainName + 'planStudent/getClassStudentList'
export const exportStudent = domainName + 'planStudent/exportStudent'
export const getStudentViewInfo = domainName + 'planStudent/getStudentViewInfo'
export const publishPlanClass = domainName + 'planSession/publishPlanClass'
export const getDeskTitleContent = domainName + 'planSession/getDeskTitleContent'
export const querySignSessionList = domainName + 'planSession/querySignSessionList'
export const querySignPlaceList = domainName + 'place/querySignPlaceList'
export const querySignClassList = domainName + 'planClass/querySignClassList'
export const getBatchSignTable = domainName + 'planSession/getBatchSignTable'
export const getPlanAllSession = domainName + 'planSession/getPlanAllSession'
export const createSignTable = domainName + 'planSession/createSignTable'
export const getClassesByPlanSessionPlace = domainName + 'planSession/getClassesByPlanSessionPlace'
export const getOtherClasses = domainName + 'planSession/getOtherClasses'
export const getClassesStudentCount = domainName + 'planSession/getClassesStudentCount'
export const getClassesStudentInfo = domainName + 'planSession/getClassesStudentInfo'
export const saveChangePlanClass = domainName + 'planSession/saveChangePlanClass'
export const getPlanPlaceSessionClass = domainName + 'examOrderCode/getPlanPlaceSessionClass'
export const exportExamOrderCode = domainName + 'examOrderCode/exportExamOrderCode'
export const queryExamOrderCode = domainName + 'examOrderCode/queryExamOrderCode'
export const exportData = domainName + 'scoreReview/exportData'
export const getNextScoreReview = domainName + 'scoreReview/getNextScoreReview'
export const updateAuditState = domainName + 'scoreReview/updateAuditState'
export const getPageList = domainName + 'scoreReview/getPageList'
export const getScoreReview = domainName + 'scoreReview/getScoreReview'
export const uploadScoreReview = domainName + 'scoreReview/uploadScoreReview'
export const downloadScoreReview = domainName + 'scoreReview/downloadScoreReview'
export const getCourseScoreSet = domainName + 'studentCourse/getCourseScoreSet'
export const getPlanCoursePublish = domainName + 'studentCourse/getPlanCoursePublish'
export const publishStudentScore = domainName + 'studentCourse/publishStudentScore'
export const getStudentScoreList = domainName + 'studentCourse/getStudentScoreList'
export const batchPrintCertificate = domainName + 'studentCourse/batchPrintCertificate'
export const getOtsUrl = domainName + 'studentCourse/getOtsUrl'
export const getExamCheckState = domainName + 'studentCourse/getExamCheckState'
export const changeExamCheckState = domainName + 'studentCourse/changeExamCheckState'
export const queryExamCheckState = domainName + 'studentCourse/queryExamCheckState'
export const exportStudentScore = domainName + 'studentCourse/exportStudentScore'
export const changeCourseScoreSet = domainName + 'studentCourse/changeCourseScoreSet'
export const getEnableScoreImport = domainName + 'studentCourse/getEnableScoreImport'
export const scoreImport = domainName + 'studentCourse/scoreImport'
export const importCheckStateFile = domainName + 'studentCourse/importCheckStateFile'
export const getCheckStateTemplate = domainName + 'studentCourse/getCheckStateTemplate'
export const entrancePrint = domainName + 'entrance/entrancePrint'
export const certificatePrint = domainName + 'entrance/certificatePrint'
export const score = domainName + 'signUp/score'
export const getResultList = domainName + 'signUp/getResultList'
export const updateInfo = domainName + 'signUp/updateInfo'
export const selectPayInfo = domainName + 'payment/selectPayInfo'
export const cashierInfo = domainName + 'payment/cashierInfo'
export const paymentPretreatment = domainName + 'payment/paymentPretreatment'
export const judgeIsViewPay = domainName + "plan/judgeIsViewPay"
export const getStudentExamList = domainName + 'signUp/getStudentExamList'
export const ipCheck = domainName + 'signUp/ipCheck'
export const getOtsStudentExam = domainName + 'studentCourse/getOtsStudentExam'
export const selectRegisterUserList = domainName + 'signUp/selectRegisterUserList'
export const updateRegisterUserInfo = domainName + 'signUp/updateRegisterUserInfo'
export const savePhoto = domainName + 'photo/savePhoto'
export const standardPhotoByPreview = domainName + 'photo/standardPhotoByPreview'
export const deleteDish = domainName + 'photo/deleteDish'
export const selectList = domainName + 'registration/selectList'
export const del = domainName + 'registration/delete'
export const registerUser = domainName + 'signUp/registerUser'
export const addStudent = domainName + 'registration/addStudent'
export const planStudentImport = domainName + 'planStudent/planStudentImport'
export const studentExport = domainName + 'planStudent/studentExport'
export const selectOneSignUp = domainName + 'registration/selectOneSignUp'
export const UpdateRegistration = domainName + 'signUp/UpdateRegistration'
export const batchImportUserPhoto = domainName + 'photo/batchImportUserPhoto'
export const getCurrentPlan = domainName + 'plan/getPlanById'
export const exportExamine = domainName + 'registration/exportExamine'
export const auditStudentImport = domainName + 'registration/auditStudentImport'
export const getBillList = domainName + 'bill/getBillList'
export const getBillTotal = domainName + 'bill/getBillTotal'
export const refundBill = domainName + 'bill/refundBill'
export const rePayBill = domainName + 'bill/rePayBill'
export const exportBillList = domainName + 'bill/exportBillList'
export const invoiceList = domainName + 'payment/invoiceList'
export const invoiceDownload = domainName + 'payment/invoiceDownload'
export const invoiceBatchDownload = domainName + 'payment/invoiceBatchDownload'
export const invoiceExport = domainName + 'payment/invoiceExport'
export const getCoursePayList = domainName + 'bill/getCoursePayList'
export const coursePayImport = domainName + 'bill/coursePayImport'
export const payCourseForOne = domainName + 'bill/payCourseForOne'
export const exportCoursePay = domainName + 'bill/exportCoursePay'
export const getMessageSendList = domainName + 'message/getMessageSendList'
export const getMessageSendGroupCount = domainName + 'message/getMessageSendGroupCount'
export const sendMessage = domainName + 'message/sendMessage'
export const getMessageRecordList = domainName + 'message/getMessageRecordList'
export const exportMessageRecord = domainName + 'message/exportMessageRecord'
export const reSendMessage = domainName + 'message/reSendMessage'
export const examineList = domainName + 'registration/examineList'
export const examine = domainName + 'registration/examine'
export const examineByOne = domainName + 'registration/examineByOne'
export const batchExamine = domainName + 'registration/batchExamine'
export const selectByOne = domainName + 'signUp/selectByOne'
export const examineNextOne = domainName + 'registration/examineNextOne'
export const backExamine = domainName + 'registration/backExamine'
export const examineNumber = domainName + 'registration/examineNumber'
export const getConfigData = domainName + 'config/getConfigData'
export const addConfig = domainName + 'config/addConfig'
export const exportUserArrangement = domainName + 'signUp/exportUserArrangement'
export const getConfigMessage = domainName + "message/getConfigMessage"
export const setConfigMessage = domainName + "message/setConfigMessage"
export const execute = domainName + 'operate/execute'
export const registerAgain = domainName + 'signUp/registerAgain'
export const readUserPrivilege = domainName + 'privilege/readUserPrivilege'
export const queryAllNotice = domainName + 'Notice/queryAllNotice'
export const selectNoticeById = domainName + 'Notice/selectNoticeById'
export const selectNoticeList = domainName + 'Notice/selectNoticeList'
export const updateShowStatus = domainName + 'Notice/updateShowStatus'
export const addNotice = domainName + 'Notice/addNotice'
export const updateNoticeById = domainName + 'Notice/updateNoticeById'
export const delNotice = domainName + 'Notice/delNotice'
export const issueNotice = domainName + 'Notice/issueNotice'
export const queryRole = domainName + 'role/queryRole';
export const getRoleTypeMenu = domainName + 'role/getRoleTypeMenu';
export const getEditUserData = domainName + "role/getEditUserData";
export const queryRoleUserSet = domainName + "role/queryRoleUserSet";
export const deleteUser = domainName + "role/deleteUser";
export const submitRole = domainName + "role/submitRole";
export const deleteRole = domainName + "role/deleteRole";
export const setUserRole = domainName + "role/setUserRole";
export const addRoleMenu = domainName + "role/addRoleMenu";
export const getSystemUserList = domainName + "role/getSystemUserList";
export const getTypeRoleList = domainName + "role/getTypeRoleList";
export const addSystemUser = domainName + "role/addSystemUser";
export const editUser = domainName + "role/editUser";
export const stationUserImport = domainName + "role/stationUserImport";
export const itinerantTeacherImport = domainName + "role/itinerantTeacherImport";
export const getExtDefConfigList = domainName + 'extDef/getExtDefConfigList'
export const deleteExtDefConfig = domainName + 'extDef/deleteExtDefConfig'
export const saveExtDefConfigList = domainName + 'extDef/saveExtDefConfigList'
export const selectExtDefConfig = domainName + 'extDef/selectExtDefConfig'
export const getSignDateCountExt = domainName + 'extRegistration/getSignDateCount ';
export const getUserExtInfo = domainName + 'extRegistration/getUserExtInfo';
export const getRegisterForm = domainName + 'extRegistration/getRegisterForm';
export const addStudentExt = domainName + 'extRegistration/addStudent';
export const UpdateRegistrationExt = domainName + 'extRegistration/UpdateRegistration';
export const selectOneSignUpExt = domainName + 'extRegistration/selectOneSignUp';
export const uploadExt = domainName + 'file/uploadExt';
export const selectListExt = domainName + 'extRegistration/selectList';
export const planStudentImportExt = domainName + 'extRegistration/planStudentImport';
export const studentExportExt = domainName + 'extRegistration/studentExport';
export const excelTempCreateExt = domainName + 'extRegistration/excelTempCreate';
export const examineExtList = domainName + 'extRegistration/examineExtList';
export const exportExamineExt = domainName + 'extRegistration/exportExamine';
export const selectByOneInfo = domainName + 'extRegistration/selectByOne';
export const getSyncLogData = domainName + 'oisSyncLog/getSyncLogData';
export const syncExamData = domainName + 'oisSync/syncExamData';
export const getEnableSyncExamState = domainName + 'oisSync/getEnableSyncExamState';
export const syncCheckState = domainName + 'oisSync/syncCheckState';
export const getEnableSyncCheckState = domainName + 'oisSync/getEnableSyncCheckState'
export const selectHumanList = domainName + 'human/selectHumanList';
export const batchAuditHuman = domainName + 'human/batchAuditHuman';
export const exportHuman = domainName + 'human/exportHuman';
export const batchHumanAuditEx = domainName + 'studentCourse/batchHumanAuditEx';
export const getStudentPlanLis = domainName + 'signUp/getStudentPlanList'
export const batchList = domainName + 'plan/getList '
export const getReviewTeacherList = domainName + "ReviewTeacher/getReviewTeacherList";
export const setReviewTeacher = domainName + "ReviewTeacher/saveOrUpdateReviewTeacher";
export const delReviewTeacher = domainName + "ReviewTeacher/delReviewTeacher";
export const importReviewTeacher = domainName + "ReviewTeacher/reviewTeacherImport";
export const getCourseReview = domainName + "ReviewTeacher/getCourseReview";
export const isAutoAllocation = domainName + "ReviewTeacher/isAutoAllocation";
export const importReResult = domainName + "ReviewTeacher/importResult";
export const autoLocation = domainName + "ReviewTeacher/autoAllocation";
export const delLocation = domainName + "ReviewTeacher/delAllocation";
export const delCourseReveiw = domainName + "ReviewTeacher/delCourseReview";
export const getPlanSession = domainName + "ReviewTeacher/getPlanSession";
export const getPlanCourseTeacher = domainName + "ReviewTeacher/getPlanCourseTeacher";
export const getStudentTeacher = domainName + "ReviewTeacher/getStudentTeacher";
export const selectTeacherReviewList = domainName + "ReviewTeacher/selectTeacherReviewList";
export const importTeacherReviewList = domainName + "ReviewTeacher/importTeacherReviewList";
export const bulkAllocation = domainName + "ReviewTeacher/bulkAllocation";
export const exportAllocation = domainName + "ReviewTeacher/exportAllocation";
export const getTeacherPlanList = domainName + "ReviewTeacher/getTeacherPlanList";
export const getTeacherReviewList = domainName + "ReviewTeacher/getTeacherReviewList";
export const getTeacherReviewAllList = domainName + "ReviewTeacher/getTeacherReviewAllList";
export const getTeacherReviewCount = domainName + "ReviewTeacher/getTeacherReviewCount";
export const teacherReviewToOts = domainName + "ReviewTeacher/teacherReviewToOts";
export const getReviewUrl = domainName + "ReviewTeacher/getReviewUrl";
export const getTeacherReviewTimeList = domainName + "ReviewTeacher/getTeacherReviewTimeList";
export const updateTeacherReviewTime = domainName + "ReviewTeacher/updateTeacherReviewTime";
export const judgeTimeRange = domainName + "ReviewTeacher/judgeTimeRange";
export const judgeHaveTeacher = domainName + "ReviewTeacher/judgeHaveTeacher";
export const getBanner = domainName + "screenSignAuditPay/getBanner";
export const getDataList = domainName + "screenSignAuditPay/getDataList";
export const getAuditInfo = domainName + "screenSignAuditPay/getAuditInfo";
export const getSignAndPayList = domainName + "screenSignAuditPay/getSignAndPayList";
export const querySessionAvailable = domainName + "screenExaming/querySessionAvailable";
export const queryTotalData = domainName + "screenExaming/queryTotalData";
export const querySignCount = domainName + "screenExaming/querySignCount";
export const queryPhotoList = domainName + "screenExaming/queryPhotoList";
export const querySpotCount = domainName + "screenExaming/querySpotCount";
export const queryCourseCount = domainName + "screenExaming/queryCourseCount";
export const queryCourseCountDetail = domainName + "screenExaming/queryCourseCountDetail"; //考试科目分布，包括（实考、缺考、异常）
export const queryExamIpAddress = domainName + "screenExaming/queryExamIpAddress";
export const getScreenPlanList = domainName + 'screenSignAuditPay/getScreenPlanList';
export const getPlanReviewCourse = domainName + 'planCourse/getPlanReviewCourse';
export const getScreenReviewTotal = domainName + 'screenReview/getScreenReviewTotal';
export const getScreenReviewDateCount = domainName + 'screenReview/getScreenReviewDateCount';
export const getScreenReviewCourseList = domainName + 'screenReview/getScreenReviewCourseList';
export const getScreenReviewCountList = domainName + 'screenReview/getScreenReviewCountList';
export const getScreenReviewDurationList = domainName + 'screenReview/getScreenReviewDurationList';
export const getScreenReviewScoreSection = domainName + 'screenReview/getScreenReviewScoreSection';
export const getScreenReviewInfoList = domainName + 'screenReview/getScreenReviewInfoList';
export const getPlanList = domainName + 'planExamActivity/getPlanList';
export const getSessionList = domainName + 'planExamActivity/getSessionList';
export const getCourseList = domainName + 'planExamActivity/getCourseList';
export const judgeChange = domainName + 'planExamActivity/judgeChange';
export const getActivityList = domainName + 'planExamActivity/getActivityList';
export const addPaper = domainName + 'planExamActivity/addPaper';
export const delPaper = domainName + 'planExamActivity/delPaper';
export const getIpAnalysisPlace = domainName + 'otsIpLog/getIpAnalysisPlace';
export const getIpAnalysisSession = domainName + 'otsIpLog/getIpAnalysisSession';
export const getIpAnalysisClass = domainName + 'otsIpLog/getIpAnalysisClass';
export const getPlaceByExamInfo = domainName + 'Public/getPlaceByExamInfo';
export const addTimeStudentCount = domainName + 'planStudent/addTimeStudentCount';
export const addTimeBatch = domainName + 'planStudent/addTimeBatch';
export const addTimeSingle = domainName + 'planStudent/addTimeSingle';
export const getNotice = domainName + 'Public/getNotice';
export const getUserHistoryPhoto = domainName + 'extRegistration/getUserHistoryPhoto';
export const exportPdf = domainName + 'examReport/exportPdf';
export const normalDataAllCourse = domainName + 'scoreAnalysis/normalDataAllCourse';
export const querySessionNext = domainName + 'screenExaming/querySessionNext';
export const examTypeList = domainName + "examtype/getList";
export const queryDatetimeCount = domainName + "screenExaming/queryDatetimeCount";
export const checkOtherSessionAndCopy = domainName + "plan/checkOtherSessionAndCopy";
export const checkTeacherIsSet = domainName + "plan/checkTeacherIsSet";
export const singleCopy = domainName + "plan/singleCopy";
export const copy = domainName + "plan/copy";
export const getTrialScoreLinePlanList = domainName + "studentCourse/getTrialScoreLinePlanList";
export const getTrialScoreLineList = domainName + "studentCourse/getTrialScoreLineList";
export const getTenantPayType = domainName + "payment/getTenantPayType";
export const updatePlanPhotoSet = domainName + "plan/updatePlanPhotoSet";
export const getSmartReminder = domainName + 'Initiate/getSmartReminder'
export const getHomePagePlanList = domainName + 'Initiate/getHomePagePlanList'
export const getSignDoD = domainName + 'Initiate/getSignDoD'
export const getSignDateCount = domainName + 'Initiate/getSignDateCount'
export const getAuditCount = domainName + 'Initiate/getAuditCount'
export const getAuditDateCount = domainName + 'Initiate/getAuditDateCount'
export const getPayCount = domainName + 'Initiate/getPayCount'
export const getPayDateCount = domainName + 'Initiate/getPayDateCount'
export const getDownloadEntranceCount = domainName + 'Initiate/getDownloadEntranceCount'
export const getDownloadEntranceDateCount = domainName + 'Initiate/getDownloadEntranceDateCount'
export const getExamCount = domainName + 'Initiate/getExamCount'
export const getJudgeCount = domainName + 'Initiate/getJudgeCount'
export const getScoreCount = domainName + 'Initiate/getScoreCount'
export const getPlaceMonitorQrCode = domainName + 'place/getPlaceMonitorQrCode'
export const exportPlaceMonitorQrCode = domainName + 'place/exportPlaceMonitorQrCode'
export const getSpecialInputting = domainName + 'config/getSpecialInputting'
export const getSelectClass = domainName + 'authCodeQuery/getSelectClass'
export const getSelectAuthCodeType = domainName + 'authCodeQuery/getSelectAuthCodeType'
export const queryList = domainName + 'authCodeQuery/queryList'
export const exportAuthCode = domainName + 'authCodeQuery/export'
export const exportSerialNumber = domainName + 'serialNumberQuery/export'
export const serialQueryList = domainName + 'serialNumberQuery/queryList'
export const serialGetSelectClass = domainName + 'serialNumberQuery/getSelectClass'
export const judgeImportArrangeClassInfo = domainName + 'planStudent/judgeImportArrangeClassInfo'
export const importArrangeClassInfo = domainName + 'planStudent/importArrangeClassInfo'
export const getPlanExamConfig = domainName + 'examConfig/getPlanExamConfig'
export const saveExamConfigOne = domainName + 'examConfig/saveExamConfigOne'
export const copyExamConfig = domainName + 'examConfig/copyExamConfig'
export const saveExamConfigTwo = domainName + 'examConfig/saveExamConfigTwo'
export const saveExamConfigThree = domainName + 'examConfig/saveExamConfigThree'
export const tryExamQueryList = domainName + 'testExamQuery/queryList'
export const tryExamExport = domainName + 'testExamQuery/export'
export const tryExamSelectClass = domainName + 'testExamQuery/getSelectClass'
export const getPlanPlaceExamConfig = domainName + 'planPlace/getPlanPlaceExamConfig'
export const getPlanPlaceExamConfigById = domainName + 'planPlace/getPlanPlaceExamConfigById'
export const savePlanPlaceExamConfig = domainName + 'planPlace/savePlanPlaceExamConfig'
export const getPlanClassSignTableList = domainName + 'planSignTable/getPlanClassSignTableList'
export const exportClassSignTable = domainName + 'planSignTable/exportClassSignTable'
export const uploadClassSignTable = domainName + 'planSignTable/uploadClassSignTable'
export const importCourse = domainName + 'course/importCourse'
export const getExamNumByCourse = domainName + 'studentCourse/getExamNumByCourse'
export const getSubCourseList = domainName + 'studentCourse/getSubCourseList'
export const getSubCourseStudentScoreList = domainName + 'studentCourse/getSubCourseStudentScoreList'
export const exportSubCourseStudentScoreList = domainName + 'studentCourse/exportSubCourseStudentScoreList'
export const getStudentSubCourseList = domainName + 'studentCourse/getStudentSubCourseList'
export const getPreGeneratedAnswerPaper = domainName + 'planSession/getPreGeneratedAnswerPaper'
export const downloadPreGeneratedAnswerPaper = domainName + 'planSession/downloadPreGeneratedAnswerPaperIndex'
export const getUnusualInfo = domainName + 'Public/getUnusualInfo'
export const checkSign = domainName + 'Public/checkSign'
export const uploadUnusualImg = domainName + 'Public/uploadUnusualImg'
export const getSignTableInfo = domainName + 'Public/getSignTableInfo'
export const uploadSignTableImg = domainName + 'Public/uploadSignTableImg'
export const queryEnterKeyList = domainName + 'planClass/queryEnterKeyList'
export const exportEnterKeyDetail = domainName + 'planClass/exportEnterKeyDetail'
export const queryEnterKeyDetailList = domainName + 'planClass/queryEnterKeyDetailList'
export const examStudentQueryList = domainName + 'examStudentDetailQuery/queryList'
export const queryDetailList = domainName + 'examStudentDetailQuery/queryDetailList'
export const versionQueryList = domainName + 'planVersionCodeQuery/queryList'
export const getSessionConfig = domainName + 'planSession/getSessionConfig'
export const saveSessionConfig = domainName + 'planSession/saveSessionConfig'
export const copySessionConfig = domainName + 'planSession/copySessionConfig'
export const unfreezeAccount = domainName + 'signUp/unfreezeAccount'
export const queryExamList = domainName + 'serialNumberQuery/queryExamList'
export const uploadExamPackageByBatch = domainName + 'planSession/uploadExamPackageByBatch'
export const exportPlaceToPdf = domainName + 'serialNumberQuery/exportPlaceToPdf'
export const queryExamSubmitNum = domainName + 'planSession/queryExamSubmitNum'
export const submitByForce = domainName + 'planStudent/submitByForce'

export const getEntranceTemplate = domainName + 'entrance/getEntranceTemplate'
export const getEntranceProperty = domainName + 'entrance/getEntranceProperty'
export const saveEntrancePrintPosition = domainName + 'entrance/saveEntrancePrintPosition'
export const getCertificateTemplate = domainName + 'entrance/getCertificateTemplate'
export const getCertificateProperty = domainName + 'entrance/getCertificateProperty'
export const saveCertificatePrintPosition = domainName + 'entrance/saveCertificatePrintPosition'

export const photoVerifyLog = domainName + 'photo/photoVerifyLog'
export const photoVerifyLogDelete = domainName + 'photo/photoVerifyLogDelete'
export const applyList = domainName + 'scoreModifyOrder/applyList'
export const applyExport = domainName + 'scoreModifyOrder/applyExport'
export const getReasonList = domainName + 'courseExempt/getReasonList'
export const saveReason = domainName + 'courseExempt/saveReason'
export const getOrderFile = domainName + 'scoreModifyOrder/getOrderFile'
export const applySubmit = domainName + 'scoreModifyOrder/applySubmit'
export const applyOrderInfo = domainName + 'scoreModifyOrder/applyOrderInfo'
export const uploadFile = domainName + 'scoreModifyOrder/uploadFile'
export const applyCancel = domainName + 'scoreModifyOrder/applyCancel'
export const auditNext = domainName + 'scoreModifyOrder/auditNext'
export const auditSubmit = domainName + 'scoreModifyOrder/auditSubmit'
export const auditCancel = domainName + 'scoreModifyOrder/auditCancel'
export const updateReason = domainName + 'courseExempt/updateReason'
export const operationReason = domainName + 'courseExempt/operationReason'
export const getReasonCourseList = domainName + 'courseExempt/getReasonCourseList'
export const getReasonApplyList = domainName + 'courseExempt/getReasonApplyList'
export const uploadMaterial = domainName + 'courseExempt/uploadMaterial'
export const getReasonMaterialList = domainName + 'courseExempt/getReasonMaterialList'
export const saveReasonInfo = domainName + 'courseExempt/saveReasonInfo'
export const deleteReasonMaterialList = domainName + 'courseExempt/deleteReasonMaterialList'
export const deleteReasonInfo = domainName + 'courseExempt/deleteReasonInfo'
export const exportReasonInfo = domainName + 'courseExempt/exportReasonInfo'
export const importReasonInfo = domainName + 'courseExempt/importReasonInfo'
export const downloadReasonInfo = domainName + 'courseExempt/downloadReasonInfo'
export const synchronousExemptInfo = domainName + 'courseExempt/synchronousExemptInfo'
export const exportSubCourseScore = domainName + 'studentCourse/exportSubCourseScore'
export const getStationsForPlan = domainName + 'station/getStationsForPlan'
export const sendSmsForSign = domainName + 'registration/sendSmsForSign'
export const getPlanCourseExempt = domainName + 'planCourseExempt/getPlanCourseExempt'
export const getPlanCourseExemptScope = domainName + 'planCourseExempt/getPlanCourseExemptScope'
export const getExemptReasonList = domainName + 'planCourseExempt/getExemptReasonList'
export const uploadExemptFile = domainName + 'planCourseExempt/uploadExemptFile'
export const getStudentCourseExemptList = domainName + 'planCourseExempt/getStudentCourseExemptList'
export const exportStudentCourseExemptFile = domainName + 'planCourseExempt/exportStudentCourseExemptFile'
export const uploadExamDataBakByBatch = domainName + 'planSession/uploadExamDataBakByBatch'
export const publishPreJudgeExempt = domainName + 'studentCourse/publishPreJudgeExempt'
export const getTypeList = domainName + 'planCourseScoreType/getTypeList'
export const insertTypeName = domainName + 'planCourseScoreType/insertTypeName'
export const updateTypeName = domainName + 'planCourseScoreType/updateTypeName'
export const operationType = domainName + 'planCourseScoreType/operationType'
export const getPlanTypeList = domainName + 'planCourseScoreType/getPlanTypeList'
export const operationPlanType = domainName + 'planCourseScoreType/operationPlanType'
export const deletePlanType = domainName + 'planCourseScoreType/deletePlanType'
export const getTypeSetList = domainName + 'planCourseScoreType/getTypeSetList'
export const operationTypeSet = domainName + 'planCourseScoreType/operationTypeSet'
export const getBatchTypeSetInfo = domainName + 'planCourseScoreType/getBatchTypeSetInfo'
export const batchOperationTypeSet = domainName + 'planCourseScoreType/batchOperationTypeSet'
export const getUserTypeScoreList = domainName + 'planCourseScoreType/getUserTypeScoreList'
export const copySourcePlanTypeScore = domainName + 'planCourseScoreType/copySourcePlanTypeScore'
export const deleteUserTypeScore = domainName + 'planCourseScoreType/deleteUserTypeScore'
export const exportUserTypeScore = domainName + 'planCourseScoreType/exportUserTypeScore'
export const importUserTypeScore = domainName + 'planCourseScoreType/importUserTypeScore'
export const saveUserTypeScore = domainName + 'planCourseScoreType/saveUserTypeScore'
export const exportLevelSubjectCourseByRequirement = domainName + 'levelSubjectCourse/exportLevelSubjectCourseByRequirement'
export const exportLevelBlurred = domainName + 'level/exportLevelBlurred'
export const exportCourseList = domainName + 'course/exportCourseList'
export const exportSubjectList = domainName + 'subject/exportSubjectList'
export const queryExamSubmitList = domainName + 'planSession/queryExamSubmitList'
export const exprotExamSubmitList = domainName + 'planSession/exprotExamSubmitList'
export const exprotExamSubmitNum = domainName + 'planSession/exprotExamSubmitNum'
export const getPlanPartInfo = domainName + 'plan/getPlanPartInfo'
export const getComputerExamPhotoList = domainName + 'photo/getComputerExamPhotoList'
export const uploadComputerExamSinglePhoto = domainName + 'photo/uploadComputerExamSinglePhoto'
export const checkAllSessionIsEnd = domainName + 'photo/checkAllSessionIsEnd'
export const uploadComputerExamBatchPhoto = domainName + 'photo/uploadComputerExamBatchPhoto'
export const getCertificateInfo = domainName + 'Public/getCertificateInfo'
export const getComputerExamClassList = domainName + 'photo/getComputerExamClassList'
export const checkPhoto = domainName + 'photo/checkPhoto'
export const uploadStationFiles = domainName + 'stationFiles/uploadStationFiles'
export const getStationFiles = domainName + 'stationFiles/getStationFiles'
export const saveStationFiles = domainName + 'stationFiles/saveStationFiles'
export const deleteStationFiles = domainName + 'stationFiles/deleteStationFiles'
export const getAuditList = domainName + 'stationFiles/getAuditList'
export const saveAuditFiles = domainName + 'stationFiles/saveAuditFiles'
export const cancelAuditFiles = domainName + 'stationFiles/cancelAuditFiles'
export const exportAuditFiles = domainName + 'stationFiles/exportAuditFiles'
export const exportAuditFilesInfo = domainName + 'stationFiles/exportAuditFilesInfo'
export const studentFilesUpload = domainName + 'studentFiles/studentFilesUpload'
export const planFileSetList = domainName + 'studentFiles/planFileSetList'
export const studentFilesList = domainName + 'studentFiles/studentFilesList'
export const studentFilesDelete = domainName + 'studentFiles/studentFilesDelete'
export const exportStudentFiles = domainName + 'planStudent/exportStudentFiles'
export const getStationFilesPlan = domainName + 'stationFiles/getStationFilesPlan'
export const getStationFilesStation = domainName + 'stationFiles/getStationFilesStation'
export const getStudentScoreReviewSubCourseInfo = domainName + 'scoreReview/getStudentScoreReviewSubCourseInfo'
export const getStudentScoreReviewSubCourseDetail = domainName + 'scoreReview/getStudentScoreReviewSubCourseDetail'

export const planFileAgentList = domainName + 'studentFiles/agentList' // 智能体的下拉框
export const planFileSetAdd = domainName + 'studentFiles/planFileSetAdd'
export const planFileSetModify = domainName + 'studentFiles/planFileSetModify'
export const planFileSetDelete = domainName + 'studentFiles/planFileSetDelete'
export const downloadJobFileById = domainName + 'jobs/downloadJobFileById'
export const exportDownList = domainName + 'jobs/getList'
export const getUnreadCount = domainName + 'jobs/getUnreadCount'
export const updateReaded = domainName + 'jobs/updateReaded'
export const checkStudentSignPlanExclusive = domainName + 'extRegistration/checkStudentSignPlanExclusive'
export const getSignDateForPlanId = domainName + 'extRegistration/getSignDateForPlanId'
export const getDetecteTemplateById = domainName + 'intelligentDetecte/getDetecteTemplateById'
export const getListDetecteTemplate = domainName + 'intelligentDetecte/getListDetecteTemplate'
export const addDetecteTemplate = domainName + 'intelligentDetecte/addDetecteTemplate'
export const updateDetecteTemplate = domainName + 'intelligentDetecte/updateDetecteTemplate'
export const deleteDetecteTemplate = domainName + 'intelligentDetecte/deleteDetecteTemplate'
export const intelligentDetecte4Ots = domainName + 'intelligentDetecte/intelligentDetecte4Ots'
export const getTaskList = domainName + 'intelligentDetecte/getTaskList'
export const getTaskItem = domainName + 'intelligentDetecte/getTaskItem'
export const createTask4IntelligentDetecte = domainName + 'intelligentDetecte/createTask4IntelligentDetecte'
export const deleteTask = domainName + 'intelligentDetecte/deleteTask'
export const stopTask = domainName + 'intelligentDetecte/stopTask'
export const getOtsQuestionCount = domainName + 'intelligentDetecte/getOtsQuestionCount'
export const generateTaskReport = domainName + 'intelligentDetecte/generateTaskReport'
export const getQuestionState = domainName + 'intelligentDetecte/getQuestionState'
export const getQuestionType = domainName + 'intelligentDetecte/getQuestionType'
export const getDetecteItemList = domainName + 'intelligentDetecte/getDetecteItemList'
export const setDefaultDetecteTemplate = domainName + 'intelligentDetecte/setDefaultDetecteTemplate'
export const createTask4CheckSimilar = domainName + 'intelligentDetecte/createTask4CheckSimilar'
export const getTaskItemUnokCount = domainName + 'intelligentDetecte/getTaskItemUnokCount'
export const getTaskDetecteInfo = domainName + 'intelligentDetecte/getTaskDetecteInfo'
export const getTaskDetecteDescription = domainName + 'intelligentDetecte/getTaskDetecteDescription'
export const getTaskById = domainName + 'intelligentDetecte/getTaskById'
export const getPlanArchiveList = domainName + 'planArchive/getList'
export const getPlanArchiveListFile = domainName + 'planArchive/getListFile'
export const planArchiveArchiveOperate = domainName + 'planArchive/archiveOperate'
export const planArchiveDownloadOperate = domainName + 'planArchive/downloadOperate'
export const planArchiveDeleteOperate = domainName + 'planArchive/deleteOperate'
export const exportSignPhoto = domainName + 'planStudent/exportSignPhoto'
export const syncSignPhotoWithPlans = domainName + 'planStudent/syncSignPhotoWithPlans'
export const fillBlankImageWithPlanId = domainName + 'planStudent/fillBlankImageWithPlanId'
export const getFieldModifyScope = domainName + 'extRegistration/getFieldModifyScope'
export const getFieldModifyScopeByPlanId = domainName + 'extRegistration/getFieldModifyScopeByPlanId'
export const exportEntrance = domainName + 'planStudent/exportEntrance'
export const taskList = domainName + 'standardTask/taskList'
export const uploadQuestionFile = domainName + 'standardTask/uploadQuestionFile'
export const taskSave = domainName + 'standardTask/taskSave'
export const taskChangeDelete = domainName + 'standardTask/taskChangeDelete'
export const taskChangeWait = domainName + 'standardTask/taskChangeWait'
export const taskChangeWaitAgain = domainName + 'standardTask/taskChangeWaitAgain'
export const taskDownloadQuestion = domainName + 'standardTask/taskDownloadQuestion'
export const taskDownloadOriFile = domainName + 'standardTask/taskDownloadOriFile'
export const addCourseSub = domainName + 'course/addCourseSub'
export const getCourseSubList = domainName + 'course/getCourseSubList'
export const getCourseSubAll = domainName + 'course/getCourseSubAll'
export const editPlanCourseSub = domainName + 'planCourse/editPlanCourseSub'
export const getPlanCourseSubList = domainName + 'planCourse/getPlanCourseSubList'
export const tokenList = domainName + 'money/list'
export const tokenSave = domainName + 'money/save'
export const getScoreListPdf = domainName + 'studentCourse/getScoreListPdf'
export const getExamLoginAbnormal = domainName + 'studentCourse/getExamLoginAbnormal'
export const getExamLoginAbnormalInfo = domainName + 'studentCourse/getExamLoginAbnormalInfo'
export const publishStudentScoreWarning = domainName + 'studentCourse/publishStudentScoreWarning'
export const getPlanStudentInfo = domainName + 'Public/getPlanStudentInfo'
export const getPlanStudentAsk = domainName + 'Public/getPlanStudentAsk'
export const savePlanStudentAsk = domainName + 'Public/savePlanStudentAsk'
export const getAskList = domainName + 'planStudent/getAskList'
export const exportAskList = domainName + 'planStudent/exportAskList'
export const saveUserTypeScoreByBatch = domainName + 'planCourseScoreType/saveUserTypeScoreByBatch'
export const downloadTrialFile = domainName + 'studentCourse/downloadTrialFile'
export const uploadTrialFile = domainName + 'studentCourse/uploadTrialFile'
export const getCategoryTree = domainName + 'standardTask/getCategoryTree'
export const getQuestionTypeByTaskIdAndCourseId = domainName + 'standardTask/getQuestionTypeByTaskIdAndCourseId'
export const getQuestionForWaitQueue = domainName + 'standardTask/getQuestionForWaitQueue'
export const getQuestionForWaitNumber = domainName + 'standardTask/getQuestionForWaitNumber'
export const getQuestionForCountTotal = domainName + 'standardTask/getQuestionForCountTotal'
export const getQuestionForCountDetail = domainName + 'standardTask/getQuestionForCountDetail'
export const saveQuestionForOts = domainName + 'standardTask/saveQuestionForOts'
export const saveQuestionSingle = domainName + 'standardTask/saveQuestionSingle'
export const saveQuestionBatch = domainName + 'standardTask/saveQuestionBatch'
export const saveQuestionField = domainName + 'standardTask/saveQuestionField'
export const saveQuestionField4Sub = domainName + 'standardTask/saveQuestionField4Sub'
export const saveScoreLine = domainName + 'studentCourse/saveScoreLine'
export const getScoreLine = domainName + 'studentCourse/getScoreLine'
export const getScoreLineCount = domainName + 'studentCourse/getScoreLineCount'
export const exportScoreLineCount = domainName + 'studentCourse/exportScoreLineCount'
export const getScoreLinePassCount = domainName + 'studentCourse/getScoreLinePassCount'
export const exportScoreLinePassCount = domainName + 'studentCourse/exportScoreLinePassCount'
export const savePlanCheckStateScope = domainName + 'planCourseScoreType/savePlanCheckStateScope'
export const getPlanCheckStateScope = domainName + 'planCourseScoreType/getPlanCheckStateScope'
export const getPhoneAndEmailConfig = domainName + 'extDef/getPhoneAndEmailConfig'
export const savePhoneAndEmailConfig = domainName + 'extDef/savePhoneAndEmailConfig'
export const aiGetLastConversation = domainName + 'chat/getLastConversation'
export const aiSubmitQuestion = domainName + 'chat/submitQuestion'
export const planFileSetSampleTemplate = domainName + 'studentFiles/planFileSetSampleTemplate'
export const planFileSetModifyRequired = domainName + 'studentFiles/planFileSetModifyRequired'
export const getCardTypeList = domainName + 'Public/getCardTypelist'
export const getSessionCourseVoList = domainName + 'planSession/getSessionCourseVoList'

export const scoredRuleList = domainName + 'scoredResult/scoredRuleList' // 赋分规则查询列表
export const scoredRuleListExport = domainName + 'scoredResult/scoredRuleListExport' // 赋分规则查询列表导出

export const getScoredRuleInfoBySetId = domainName + 'scoredResult/getScoredRuleInfoBySetId' // 查询某个setId的赋分规则的统计详情
export const getScoredRuleBySetId = domainName + 'scoredResult/getScoredRuleBySetId' // 查询某个setId的赋分规则

export const scoredRuleSave = domainName + 'scoredResult/scoredRuleSave' // 保存赋分规则
export const scoredRuleExecute = domainName + 'scoredResult/scoredRuleExecute' // 执行赋分规则

export const getScoredDetailBySetId = domainName + 'scoredResult/getScoredDetailBySetId' // 执行赋分规则后，查询各等级的统计信息
export const getScoredStudentListBySetId = domainName + 'scoredResult/getScoredStudentListBySetId' // 执行赋分规则后，查询各等级的学生清单
export const getScoredStudentListBySetIdExport = domainName + 'scoredResult/getScoredStudentListBySetIdExport' // 执行赋分规则后，查询各等级的学生清单,导出

export const confirmScoredRuleBySetId = domainName + 'scoredResult/confirmScoredRuleBySetId' // 确定使用赋分结果（单个设置）
export const confirmScoredRuleByPlanId = domainName + 'scoredResult/confirmScoredRuleByPlanId' // 确定使用赋分结果
export const resetScoredRuleByPlanId = domainName + 'scoredResult/resetScoredRuleByPlanId' // 重新初始化赋分数据

export const scoredRuleResultList = domainName + 'scoredResult/scoredRuleResultList' // 赋分明细查询
export const scoredRuleResultExport = domainName + 'scoredResult/scoredRuleResultExport' // 赋分明细查询导出


// 报名管理，导入考生，异步导入的功能接口
export const planStudentImportFile = domainName + 'planStudentImportFile/planStudentImportFile' // 报名管理：考生数据导入
export const planStudentImportFileList = domainName + 'planStudentImportFile/planStudentImportFileList' // 报名管理：查询导入的列表
export const planStudentImportFileErrorDataExport = domainName + 'planStudentImportFile/planStudentImportFileErrorDataExport' // 报名管理：下载那些导入失败的结果


// 考前更换试卷
export const getWaitConfirmCount = domainName + 'sessionVersion/getWaitConfirmCount' // 1 待确认的场次总数
export const getConfirmList = domainName + 'sessionVersion/getConfirmList' // 2 试卷变更的确认列表页
export const confirmSessionVersion = domainName + 'sessionVersion/confirmSessionVersion' // 3 试卷变更的确认操作
export const unConfirmSessionVersion = domainName + 'sessionVersion/unConfirmSessionVersion' // 4 试卷变更的取消确认操作
export const downloadSessionVersion = domainName + 'sessionVersion/downloadSessionVersion' // 5 试卷变更的下载操作
export const downloadGetLogList = domainName + 'sessionVersion/downloadGetLogList' // 6 试卷变更的下载日志的查询

// 机房考试参数配置(租户级)
export const getExamConfigBase = domainName + 'examConfigBase/getConfig' // 获取考试参数配置
export const saveExamConfigBase = domainName + 'examConfigBase/saveConfig' // 保存考试参数配置

// 准考证号管理
export const getSubjectListByPlanId = domainName + 'entranceRule/getSubjectListByPlanId' // 批次下的报名考试涉及的专业列表
export const getSystemDefaultRule = domainName + 'entranceRule/getSystemDefaultRule' // 准考证号系统默认规则说明
export const getCustomRuleByPlanId = domainName + 'entranceRule/getCustomRuleByPlanId' // 准考证号的自定义规则（通用的、各个专业的）
export const saveCustomRuleByPlanId = domainName + 'entranceRule/saveCustomRuleByPlanId' // 准考证号的自定义规则（通用的、各个专业的）
export const entranceExportTemplate = domainName + 'entranceRule/entranceExportTemplate' // 准考证号的模板，下载模板的接口
export const entranceImport = domainName + 'entranceRule/entranceImport' // 准考证号的导入
export const entranceImportDataList = domainName + 'entranceRule/entranceImportDataList' // 准考证号的导入的数据

// 合格证号管理
export const getSubjectListByPlanIdCert = domainName + 'certificateRule/getSubjectListByPlanId' // 批次下的报名考试涉及的专业列表
export const getSystemDefaultRuleCert = domainName + 'certificateRule/getSystemDefaultRule' // 合格证号系统默认规则说明
export const getCustomRuleByPlanIdCert = domainName + 'certificateRule/getCustomRuleByPlanId' // 合格证号的自定义规则（通用的、各个专业的）
export const saveCustomRuleByPlanIdCert = domainName + 'certificateRule/saveCustomRuleByPlanId' // 合格证号的自定义规则（通用的、各个专业的）
export const certificateExportTemplate = domainName + 'certificateRule/certificateExportTemplate' // 合格证号的模板，下载模板的接口
export const certificateImport = domainName + 'certificateRule/certificateImport' // 合格证号的导入
export const certificateImportDataList = domainName + 'certificateRule/certificateImportDataList' // 合格证号的导入的数据

// 考试报告AI检查
export const examReportAiCheckList = domainName + 'examReport/aiCheckList' // 查询考试报告AI检查清单
export const examReportAiCheckProgress = domainName + 'examReport/aiCheckProgress' // 查询考试报告AI检测的进度和详情
export const examReportAiCheckTask = domainName + 'examReport/aiCheckTask' // 发起考试报告AI检测的异步任务

// 试卷难度分析
export const paperAnalysisTaskList = domainName + 'paperAnalysis/taskList'
export const paperAnalysisCreateTask = domainName + 'paperAnalysis/createTask'
export const paperAnalysisModifyTask = domainName + 'paperAnalysis/modifyTask'
export const paperAnalysisDeleteTask = domainName + 'paperAnalysis/deleteTask'
export const paperAnalysisStartTask = domainName + 'paperAnalysis/startTask'
export const paperAnalysisStopTask = domainName + 'paperAnalysis/stopTask'
export const paperAnalysisTaskProgress = domainName + 'paperAnalysis/taskProgress'
export const paperAnalysisTaskResult = domainName + 'paperAnalysis/taskResult'
export const paperAnalysisTaskDetail = domainName + 'paperAnalysis/taskDetail'
export const paperAnalysisCourseDetail = domainName + 'paperAnalysis/courseDetail'
export const paperAnalysisFixedPaperCharts = domainName + 'paperAnalysis/fixedPaperCharts'
export const paperAnalysisRandomPaperCharts = domainName + 'paperAnalysis/randomPaperCharts'
export const paperAnalysisQuestionList = domainName + 'paperAnalysis/questionList'
export const paperAnalysisBatchOptions = domainName + 'paperAnalysis/batchOptions'
export const paperAnalysisCourseOptions = domainName + 'paperAnalysis/courseOptions'
export const paperAnalysisExportExcel = domainName + 'paperAnalysis/exportExcel'
export const paperAnalysisExportPdf = domainName + 'paperAnalysis/exportPdf'

// 模拟考试，支持多课程
export const planMockGetCourselist = domainName + 'planMock/getCourselist' // 获取课程列表
export const planMockSaveMock = domainName + 'planMock/saveMock' // 保存模考设置（新增/编辑）
export const planMockDeleteMock = domainName + 'planMock/deleteMock' // 删除模考设置
export const studentMockGetCourseMockList = domainName + 'studentMock/getCourseMockList' // 获取课程模考统计列表
export const studentMockGetStudentMockList = domainName + 'studentMock/getStudentMockList' // 获取学生模考列表（分页）
export const studentMockGetMockRecordLog = domainName + 'studentMock/getMockRecordLog' // 获取单个学生的模考日志
export const studentMockGetStudentMockExport = domainName + 'studentMock/getStudentMockExport' // 导出学生模考列表
export const studentMockGetMyMockList = domainName + 'studentMock/getMyMockList' // 获取学生本人的模考列表（时间轴插槽）
export const studentMockGetMessageSendGroupCount = domainName + 'studentMock/getMessageSendGroupCount' // 获取模考短信督导发送数量统计
export const studentMockSendMessage = domainName + 'studentMock/sendMessage' // 发送模考短信督导



